<table class="w-full text-left rtl:text-right text-gray-500 purple-bg">
	<thead class="text-white text-xs semi-bold top-0 z-10">
		<tr>
			<th class="px-2 py-2"></th>
			<th class="px-2 py-2"></th>

			<th [sortableHeader]="sortColumns.MAC_ADDRESS" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				Mac Address
				<i [class]="getSortIconClass(sortColumns.MAC_ADDRESS)" class="ml-1"></i>
			</th>

			<th [sortableHeader]="sortColumns.NAME" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				Name
				<i [class]="getSortIconClass(sortColumns.NAME)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.HOSTNAME" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				Hostname
				<i [class]="getSortIconClass(sortColumns.HOSTNAME)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.MODEL" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				Model
				<i [class]="getSortIconClass(sortColumns.MODEL)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.NOTES" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				Notes
				<i [class]="getSortIconClass(sortColumns.NOTES)" class="ml-1"></i>
			</th>
			<th class="px-2 py-2">
				<i class="far fa-trash"></i>
			</th>
		</tr>
	</thead>
	<tbody class="text-black">
		<tr *ngFor="let player of tableData | sortable : sortConfig : valueAccessor" class="bg-white border-b text-[12px] xl:text-sm">
			<td class="py-2 px-2">
				<button
					(click)="onEditClick(player)"
					class="!w-auto text-black bg-gray-200 focus:outline-hidden hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded text-sm px-3 py-2.5 me-2"
				>
					Edit
				</button>
			</td>
			<td class="py-2 px-2">
				<button
					(click)="onErrorLogsClick(player)"
					class="!w-auto text-black bg-gray-200 focus:outline-hidden hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded text-sm px-3 py-2.5 me-2"
				>
					Error logs
				</button>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black">{{ player.MacAddress }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black semi-bold">{{ player.PlayerName }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black">{{ player.Hostname }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black">{{ player.PlayerModel?.Name }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black">{{ player.PlayerNotes }}</p>
			</td>
			<td class="py-2 px-2">
				<button
					(click)="onDeleteClick(player)"
					class="!w-auto text-red-500 focus:outline-hidden hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded text-sm px-3 py-2.5 me-2"
				>
					<i class="far fa-trash-alt"></i>
				</button>
			</td>
		</tr>
	</tbody>
</table>
